/**
 * Story Service API types. Base path /api; auth x-demo-key.
 * See plan / Story Service route notes for error shapes and response types.
 */

/** One entry in the GET /api/story/demos response array. */
export interface DemoListItem {
  demoId: string;
  activeVersion: string;
  maxStep: number;
  recommendedStartStep: number;
  availableVersions: string[];
  pointer: { step: number; updatedAt: string } | null;
}

/** Response shape for GET /api/story/demos. */
export interface StoryDemosResponse {
  demos: DemoListItem[];
}

export interface StoryMetaResponse {
  demoId: string;
  activeVersion: string;
  maxStep: number;
  recommendedStartStep: number;
}

export interface StoryPointerResponse {
  demoId: string;
  step: number;
  updatedAt: string;
}

export interface StoryStepPayloadResponse {
  demoId: string;
  step: number;
  version: string;
  payload: {
    'client.chat.thread'?: Record<string, unknown>;
    'fa.chat.thread'?: Record<string, unknown>;
    'shared.metrics'?: Record<string, unknown>;
  };
}

export interface StoryStepKeyResponse {
  demoId: string;
  step: number;
  version: string;
  endpointKey: string;
  value: unknown;
}

/** Response shape for advance, rewind, and current — includes full step payload. */
export interface StoryStepCurrentResponse {
  demoId: string;
  pointer: { step: number; updatedAt: string };
  version: string;
  payload: Record<string, unknown>;
}

export type StoryErrorCode = 'UNAUTHORIZED' | 'NOT_FOUND' | 'BAD_REQUEST' | 'INTERNAL' | 'CONFLICT';

export interface StoryErrorBody {
  error: {
    code: StoryErrorCode;
    message: string;
    details?: unknown;
  };
}
